export default "__VITE_ASSET__DWX34ruT__"